var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPorCobrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.922,
    height: 33.67,
    viewBox: "0 0 58.922 33.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M2.25,6.75V40.42H61.172V6.75ZM23.359,36.211H12.785a6.32,6.32,0,0,0-6.326-6.326V19.376a8.425,8.425,0,0,0,8.417-8.417h8.483a19.637,19.637,0,0,0-4.274,12.626A19.637,19.637,0,0,0,23.359,36.211Zm33.6-6.326a6.36,6.36,0,0,0-6.313,6.326H40.063a19.637,19.637,0,0,0,4.274-12.626,19.637,19.637,0,0,0-4.274-12.626h8.483a8.425,8.425,0,0,0,8.417,8.417Z",
    transform: "translate(-2.25 -6.75)",
    fill: "#e56da1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorCobrar);
export default __webpack_public_path__ + "static/media/por-cobrar.4432f80ac1109825c6bafac620d22d8e.svg";
export { ForwardRef as ReactComponent };